import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromBars from './bars.reducer';

export const selectBarState = createSelector(selectDashboardState, (dashboard) => dashboard?.bar);

export const selectBars = createSelector(selectBarState, fromBars.selectAll);

export const selectSelectedBar = createSelector(selectBarState, (barState) => barState?.selectedBar);
